export default __webpack_public_path__ + "1aa1629686665028fcd22b6be3500d69.svg";